

const INITIAL_STATE = {
    USStateList:
    [
        {
            "statecode": 29,
            "statename": "Missouri"
        },
        {
            "statecode": 48,
            "statename": "Texas"
        },
        {
            "statecode": 25,
            "statename": "Massachusetts"
        },
        {
            "statecode": 36,
            "statename": "New York"
        },
        {
            "statecode": 72,
            "statename": "Puerto Rico"
        },
        {
            "statecode": 21,
            "statename": "Kentucky"
        },
        {
            "statecode": 19,
            "statename": "Iowa"
        },
        {
            "statecode": 12,
            "statename": "Florida"
        },
        {
            "statecode": 13,
            "statename": "Georgia"
        },
        {
            "statecode": 47,
            "statename": "Tennessee"
        },
        {
            "statecode": 51,
            "statename": "Virginia"
        },
        {
            "statecode": 18,
            "statename": "Indiana"
        },
        {
            "statecode": 16,
            "statename": "Idaho"
        },
        {
            "statecode": 38,
            "statename": "North Dakota"
        },
        {
            "statecode": 0,
            "statename": "Armed Forces Europe"
        },
        {
            "statecode": 32,
            "statename": "Nevada"
        },
        {
            "statecode": 1,
            "statename": "Alabama"
        },
        {
            "statecode": 8,
            "statename": "Colorado"
        },
        {
            "statecode": 39,
            "statename": "Ohio"
        },
        {
            "statecode": 10,
            "statename": "Delaware"
        },
        {
            "statecode": 28,
            "statename": "Mississippi"
        },
        {
            "statecode": 42,
            "statename": "Pennsylvania"
        },
        {
            "statecode": 56,
            "statename": "Wyoming"
        },
        {
            "statecode": 49,
            "statename": "Utah"
        },
        {
            "statecode": 53,
            "statename": "Washington"
        },
        {
            "statecode": 55,
            "statename": "Wisconsin"
        },
        {
            "statecode": 68,
            "statename": "Marshall Islands"
        },
        {
            "statecode": 4,
            "statename": "Arizona"
        },
        {
            "statecode": 27,
            "statename": "Minnesota"
        },
        {
            "statecode": 54,
            "statename": "West Virginia"
        },
        {
            "statecode": 37,
            "statename": "North Carolina"
        },
        {
            "statecode": 9,
            "statename": "Connecticut"
        },
        {
            "statecode": 6,
            "statename": "California"
        },
        {
            "statecode": 23,
            "statename": "Maine"
        },
        {
            "statecode": 40,
            "statename": "Oklahoma"
        },
        {
            "statecode": 60,
            "statename": "American Samoa"
        },
        {
            "statecode": 33,
            "statename": "New Hampshire"
        },
        {
            "statecode": 31,
            "statename": "Nebraska"
        },
        {
            "statecode": 24,
            "statename": "Maryland"
        },
        {
            "statecode": 20,
            "statename": "Kansas"
        },
        {
            "statecode": 69,
            "statename": "Northern Mariana Islands"
        },
        {
            "statecode": 0,
            "statename": "Armed Forces Pacific"
        },
        {
            "statecode": 35,
            "statename": "New Mexico"
        },
        {
            "statecode": 50,
            "statename": "Vermont"
        },
        {
            "statecode": 30,
            "statename": "Montana"
        },
        {
            "statecode": 2,
            "statename": "Alaska"
        },
        {
            "statecode": 78,
            "statename": "U.S. Virgin Islands"
        },
        {
            "statecode": 34,
            "statename": "New Jersey"
        },
        {
            "statecode": 44,
            "statename": "Rhode Island"
        },
        {
            "statecode": 22,
            "statename": "Louisiana"
        },
        {
            "statecode": 66,
            "statename": "Guam"
        },
        {
            "statecode": 11,
            "statename": "District of Columbia"
        },
        {
            "statecode": 45,
            "statename": "South Carolina"
        },
        {
            "statecode": 41,
            "statename": "Oregon"
        },
        {
            "statecode": 46,
            "statename": "South Dakota"
        },
        {
            "statecode": 15,
            "statename": "Hawaii"
        },
        {
            "statecode": 5,
            "statename": "Arkansas"
        },
        {
            "statecode": 17,
            "statename": "Illinois"
        },
        {
            "statecode": 26,
            "statename": "Michigan"
        },
        {
            "statecode": 0,
            "statename": "Armed Forces Americas"
        }
    ]
}

const AllReportsSharedReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default AllReportsSharedReducer;